import { atom } from "recoil";

const IsDialogLoginOpenAtom = atom<boolean>({
    default: false,
    key: 'isDialogLoginOpenAtomKey'
})

export default IsDialogLoginOpenAtom;